import { useEffect, useRef, useState, useMemo, useOptimistic } from "react";
import { FiFilter } from "react-icons/fi";
import { getApiInstance } from "../../../utils/api";
import InputSearch from "../../../components/inputs/inputSearch/inputSearch";
import Button from "../../../components/button/button";
import Modal from "../../../components/modal/modal";
import Input from "../../../components/inputs/input/input";
import Notification from "../../../components/notification/notification";
import TableEditable from "../../../components/tableEditable/tableEditable";
import SectionHeader from "../../../components/sectionHeader/sectionHeader";
import Badge from "../../../components/badge/badge";
import InputDropdown from "../../../components/inputs/inputDropdown/inputDropdown";
import Tag from "../../../components/tag/tag";
import Accordion from "../../../components/accordion/accordion";
import Popup from "../../../components/popup/popup";
import { MdAttachMoney } from "react-icons/md";
import { BiExport } from "react-icons/bi";
import DateRangeCalendar from "../../../components/dateRangeCalendar/dateRangeCalendar";
import { matchesSearchInObject } from "../../../utils/searchUtils";


const estadoLabels = {
    1: "Pendiente de información",
    2: "Informado",
    3: "Proposición de nueva tarifa",
    4: "Rechazada pendiente de revisión",
    5: "Informado después de revisión",
    6: "Aprobada Atlante",
    7: "Aceptado",
    8: "Rechazado",
    9: "Desestimado",
};

const familiaMapping = {
    1: "Mobiliario Central",
    2: "Mobiliario Perimetral",
    3: "Mesas",
    4: "Probadores",
    5: "Caja",
    6: "Dotación",
    7: "Instalaciones",
    8: "Señalética",
    9: "BOH",
    10: "Detalles constructivos",
11: "Detalles instalaciones",
12: "Montaje de mobiliario",
};

const estados = [
    { id: 1, label: "Pendiente de información" },
    { id: 2, label: "Informado" },
    { id: 3, label: "Proposición de nueva tarifa" },
    { id: 4, label: "Rechazada pendiente de revisión" },
    { id: 5, label: "Informado después de revisión" },
    { id: 6, label: "Aprobada Atlante" },
    { id: 7, label: "Aceptado" },
    { id: 8, label: "Rechazado" },
    { id: 9, label: "Desestimado" },
];

const statesNoEdit = [1, 2, 3, 4, 5, 6, 9];

export default function DashboardProveedor({ user }) {
    const [searchTerm, setSearchTerm] = useState("");
    const [solicitudes, setSolicitudes] = useState([]);
    const [tableEditMode, setTableEditMode] = useState(false);
    const [selectedSolicitudes, setSelectedSolicitudes] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editSolicitud, setEditSolicitud] = useState(null);
    const [filterMuebles, setFilterMuebles] = useState([]);
    const [filterNombreTarifa, setFilterNombreTarifa] = useState([]);
    const [filterEstado, setFilterEstado] = useState([]);
    const [filterCategoria, setFilterCategoria] = useState([]);
    const [filterSubcategoria, setFilterSubcategoria] = useState([]);
    const [filterFechaInformado, setFilterFechaInformado] = useState([]);
    const [filterDiasRestantes, setFilterDiasRestantes] = useState([]);
    const [mueblesOptions, setMueblesOptions] = useState([]);
    const [tarifasOptions, setTarifasOptions] = useState([]);
    const [estadosOptions, setEstadosOptions] = useState(estados);
    const [categorias, setCategorias] = useState([]);
    const [subCategorias, setSubCategorias] = useState([]);
    const [usedFilter, setUsedFilter] = useState();
    const [isFiltersModalOpen, setIsFiltersModalOpen] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [currentSolicitudIndex, setCurrentSolicitudIndex] = useState(0);
    const notificationRef = useRef(null);
        const [filterFechaSolicitud, setFilterFechaSolicitud] = useState({
        startDate: null,
        endDate: null,
    });
    const [currentSolicitud, setCurrentSolicitud] = useState(
        solicitudes.find(
            (solicitud) =>
                solicitud.codPrecioMueble ===
                selectedSolicitudes[currentSolicitudIndex]
        )
    );
    const api = getApiInstance();

    const columnsTarifas = [
        {
            key: "estado",
            label: "Estado",
            render: (row) => {
                let variant;
                const estadoLegible =
                    estadoLabels[row.codEstado] || "Sin estado";

                switch (row.estado) {
                    case 1: // Pendiente
                        if (row.diasRestantes <= 0) {
                            variant = "danger";
                        } else {
                            variant = "default";
                        }
                        break;
                    case 2: // Informado
                        variant = "info";
                        break;
                    case 3: // Proposición de nueva tarifa
                        variant = "info";
                        break;
                    case 4: // Rechazado pendiente revisión
                        variant = "warning";
                        break;
                    case 5: // Informado después de revisión
                        variant = "info";
                        break;
                    case 6: // Revisado pendiente aceptación
                        variant = "success";
                        break;
                    case 7: // Aceptado
                        variant = "success";
                        break;
                    case 8: // Rechazado
                        variant = "danger";
                        break;
                    case 9: // Desestimado
                        variant = "danger";
                        break;
                    default:
                        variant = "default";
                }

                return <Badge label={estadoLegible} variant={variant} />;
            },
            editable: false,
        },
        {
            key: "diasRestantes",
            label: "Días Restantes",
            type: "number",
            editable: false,
            highlightDays: true,
        },
        {
            key: "rutaImagenMueble",
            label: "Imagen",
            render: (row) => (
                <img
                    src={row.rutaImagenMueble || "defaultImage.png"}
                    alt={row.nombreMueble || "Sin nombre"}
                    style={{
                        maxWidth: "48px",
                        maxHeight: "48px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                />
            ),
            editable: false,
        },
        { key: "nombreMueble", label: "Mueble", editable: false },
        { key: "referencia", label: "Referencia", editable: false },
        { key: "medida", label: "Unidades", editable: false },
        { key: "nombreTarifa", label: "Nombre tarifa", editable: false },
        {
            key: "referenciaTarifaGOI",
            label: "Referencia Tarifa GOI",
            editable: false,
            required: false,
        },
        {
            key: "precioUnidad",
            label: "Precio Unidad",
            type: "number",
            editable: false,
            required: true,
            render: (row) => {
                if (row.precioUnidad === 0) {
                    return "-";
                }

                
                if (row.precioUnidadPropuesto && row.precioUnidadPropuesto !== 0) {
					const porcentajeDiferencia = (
						((row.precioUnidadPropuesto - row.precioUnidad) / row.precioUnidad) *
						100
					).toFixed(2)

					return (
						<div style={{ display: "flex", flexDirection: "column" }}>
							<span style={{ marginBottom: "4px" }}>
								{typeof row.precioUnidad === "number"
									? row.precioUnidad
									: row.precioUnidad}{" "}
								{row.simbolo}
							</span>
							<span
								style={{
									color: "#2dbf7c",
									fontSize: "1.4rem",
									borderTop: "1px dashed #2dbf7c",
									paddingTop: "4px",
									display: "flex",
									alignItems: "center"
								}}
							>
								<span
									style={{
										marginRight: "5px",
										fontWeight: "700"
									}}
								>
									Aceptado:
								</span>
								<span>
									{row.precioUnidadPropuesto} {row.simbolo}
								</span>
								<span
									style={{
										marginLeft: "8px",
										fontSize: "1.2rem",
										fontWeight: "700",
										backgroundColor:
											porcentajeDiferencia < 0 ? "#ffe3e3" : "#d9fcec",
										color: porcentajeDiferencia < 0 ? "#db3737" : "#2dbf7c",
										padding: "2px 6px",
										borderRadius: "4px"
									}}
								>
									{porcentajeDiferencia}%
								</span>
							</span>
						</div>
					)
				}

                return `${row.precioUnidad} ${row.simbolo}`;
            },
        },
        {
            key: "comentariosProveedor",
            label: "Comentarios Proveedor",
            type: "number",
            editable: false,
        },
        {
            key: "fechaSolicitud",
            label: "Fecha Solicitud",
            render: (row) => {
                const date = new Date(row.fechaSolicitud);
                return date.toLocaleDateString();
            },
            editable: false,
        },
        { key: "plazo", label: "Plazo", type: "number", editable: false },
        {
            key: "showAll",
            label: "Desglosar precios",
            render: (row) => (
                <Button
                    label="Desglosar precios"
                    onClick={() => handleOpenEditSolicitud(row)}
                />
            ),
        },
    ];

    useEffect(() => {
        fetchSolicitudes();
    }, []);

    const fetchSolicitudes = async () => {
        const api = getApiInstance();
        try {
            const response = await api.post(
                `/api/MueblesPrecios/GetMueblesPrecioByProveedorEstados/${user.codEmpresa}`,
                [1, 2, 3, 4, 5, 6, 7, 8, 9]
            );
        // Filtrar por proveedor actual
        const soloProveedor = response.data.filter(
            solicitud => solicitud.codEmpresa === user.codEmpresa
        );
        setSolicitudes(soloProveedor);
        } catch (error) {
            console.error("Error al obtener las solicitudes:", error);
            setSolicitudes([]);
        }
    };

    const filteredSolicitudes = useMemo(() => {
        let filtered = solicitudes.filter((solicitud) =>
            matchesSearchInObject(solicitud, searchTerm)
        );

        // Filtro por Variante
        if (filterMuebles.length > 0) {
            filtered = filtered.filter((solicitud) =>
                filterMuebles.includes(solicitud.codMueble)
            );
        }

        // Filtro por Nombre Tarifa
        if (filterNombreTarifa.length > 0) {
            filtered = filtered.filter((solicitud) =>
                filterNombreTarifa.includes(solicitud.nombreTarifa)
            );
        }

        // Filtro por Estado
        if (filterEstado.length > 0) {
            filtered = filtered.filter((solicitud) => {
                return filterEstado
                    .map((estado) => estado.id)
                    .includes(solicitud.estado);
            });
        }

        // Filtro por Categoría
        if (filterCategoria.length > 0) {
            filtered = filtered.filter((solicitud) => {
                const categoria =
                    familiaMapping[solicitud.codFamilia] ||
                    familiaMapping[solicitud.codFamiliaProducto] ||
                    solicitud.categoria ||
                    solicitud.nombreCategoria ||
                    solicitud.familia ||
                    solicitud.nombreFamilia;
                return filterCategoria.includes(categoria);
            });
        }

        // Filtro por Subcategoría
        if (filterSubcategoria.length > 0) {
            filtered = filtered.filter((solicitud) => {
                return filterSubcategoria.includes(solicitud.nombreSubfamilia);
            });
        }

        // Filtro por Días Restantes (rango: [min, max])
        if (
            filterDiasRestantes.length === 2 &&
            filterDiasRestantes[0] !== "" &&
            filterDiasRestantes[1] !== ""
        ) {
            const minDias = parseInt(filterDiasRestantes[0], 10);
            const maxDias = parseInt(filterDiasRestantes[1], 10);
            filtered = filtered.filter(
                (solicitud) =>
                    solicitud.diasRestantes >= minDias &&
                    solicitud.diasRestantes <= maxDias
            );
        }

        // Filtro por Fecha Informado (rango: [fechaInicio, fechaFin])
        if (
            filterFechaInformado.length === 2 &&
            filterFechaInformado[0] !== "" &&
            filterFechaInformado[1] !== ""
        ) {
            const startDate = new Date(filterFechaInformado[0]);
            const endDate = new Date(filterFechaInformado[1]);
            filtered = filtered.filter((solicitud) => {
                if (!solicitud.fechaInformado) return false;
                const fecha = new Date(solicitud.fechaInformado);
                return fecha >= startDate && fecha <= endDate;
            });
        }

        //Filtro por Fecha Solicitado
        if (filterFechaSolicitud.startDate && filterFechaSolicitud.endDate) {
        filtered = filtered.filter((solicitud) => {
            if (!solicitud.fechaSolicitud) return false;

            const fechaSolicitud = new Date(solicitud.fechaSolicitud);
            fechaSolicitud.setHours(0, 0, 0, 0);

            const startDate = new Date(filterFechaSolicitud.startDate);
            startDate.setHours(0, 0, 0, 0);

            const endDate = new Date(filterFechaSolicitud.endDate);
            endDate.setHours(23, 59, 59, 999);

            return fechaSolicitud >= startDate && fechaSolicitud <= endDate;
        });
    }
        return filtered;
    }, [
        searchTerm,
        solicitudes,
        filterMuebles,
        filterNombreTarifa,
        filterEstado,
        filterCategoria,
        filterSubcategoria,
        filterDiasRestantes,
        filterFechaInformado,
        filterFechaSolicitud
    ]);

    useEffect(() => {
        // Para generar opciones, aplicamos TODOS los filtros excepto el que estamos generando
        const getFilteredDataExcluding = (excludeFilter) => {
            return solicitudes.filter((solicitud) => {
                // Búsqueda por término
                if (searchTerm) {
                    const matchesSearch = matchesSearchInObject(
                        solicitud,
                        searchTerm
                    );
                    if (!matchesSearch) return false;
                }

                // Aplicar todos los filtros EXCEPTO el que estamos excluyendo
                if (excludeFilter !== "mueble" && filterMuebles.length > 0) {
                    if (!filterMuebles.includes(solicitud.codMueble))
                        return false;
                }

                if (
                    excludeFilter !== "nombreTarifa" &&
                    filterNombreTarifa.length > 0
                ) {
                    if (!filterNombreTarifa.includes(solicitud.nombreTarifa))
                        return false;
                }

                if (excludeFilter !== "estado" && filterEstado.length > 0) {
                    const estadoIds = filterEstado.map((estado) => estado.id);
                    if (!estadoIds.includes(solicitud.estado)) return false;
                }

                if (
                    excludeFilter !== "categoria" &&
                    filterCategoria.length > 0
                ) {
                    const categoria =
                        familiaMapping[solicitud.codFamilia] ||
                        familiaMapping[solicitud.codFamiliaProducto] ||
                        solicitud.categoria ||
                        solicitud.nombreCategoria ||
                        solicitud.familia ||
                        solicitud.nombreFamilia;
                    if (!filterCategoria.includes(categoria)) return false;
                }

                if (
                    excludeFilter !== "subcategoria" &&
                    filterSubcategoria.length > 0
                ) {
                    if (
                        !filterSubcategoria.includes(solicitud.nombreSubfamilia)
                    )
                        return false;
                }

                // Estos filtros siempre se aplican
                if (
                    filterDiasRestantes.length === 2 &&
                    filterDiasRestantes[0] !== "" &&
                    filterDiasRestantes[1] !== ""
                ) {
                    const minDias = parseInt(filterDiasRestantes[0], 10);
                    const maxDias = parseInt(filterDiasRestantes[1], 10);
                    if (
                        !(
                            solicitud.diasRestantes >= minDias &&
                            solicitud.diasRestantes <= maxDias
                        )
                    )
                        return false;
                }

                if (
                    filterFechaInformado.length === 2 &&
                    filterFechaInformado[0] !== "" &&
                    filterFechaInformado[1] !== ""
                ) {
                    if (!solicitud.fechaInformado) return false;
                    const startDate = new Date(filterFechaInformado[0]);
                    const endDate = new Date(filterFechaInformado[1]);
                    const fecha = new Date(solicitud.fechaInformado);
                    if (!(fecha >= startDate && fecha <= endDate)) return false;
                }

                return true;
            });
        };

        const dataForMuebles = getFilteredDataExcluding("mueble");
        setMueblesOptions(
            Array.from(
                new Map(
                    dataForMuebles.map((solicitud) => [
                        solicitud.codMueble,
                        {
                            id: solicitud.codMueble,
                            nombre: solicitud.referencia,
                        },
                    ])
                ).values()
            )
        );

        const dataForTarifas = getFilteredDataExcluding("nombreTarifa");
        setTarifasOptions(
            Array.from(
                new Map(
                    dataForTarifas.map((solicitud) => [
                        solicitud.nombreTarifa,
                        {
                            id: solicitud.nombreTarifa,
                            nombre: solicitud.nombreTarifa,
                        },
                    ])
                ).values()
            )
        );

        const dataForEstados = getFilteredDataExcluding("estado");
        setEstadosOptions(
            Array.from(
                new Map(
                    dataForEstados.map((solicitud) => [
                        solicitud.estado,
                        {
                            id: solicitud.estado,
                            nombre: estados.find(
                                (estado) => estado.id === solicitud.estado
                            ).label,
                        },
                    ])
                ).values()
            )
        );

        const dataForCategorias = getFilteredDataExcluding("categoria");
        const allCategorias = dataForCategorias
            .map((solicitud) => {
                return (
                    familiaMapping[solicitud.codFamilia] ||
                    familiaMapping[solicitud.codFamiliaProducto] ||
                    solicitud.categoria ||
                    solicitud.nombreCategoria ||
                    solicitud.familia ||
                    solicitud.nombreFamilia
                );
            })
            .filter(
                (value, index, self) =>
                    value &&
                    value !== null &&
                    value !== undefined &&
                    self.indexOf(value) === index
            )
            .sort(); // Ordenar alfabéticamente para consistencia
        setCategorias(allCategorias);

        const dataForSubcategorias = getFilteredDataExcluding("subcategoria");
        const allSubcategorias = dataForSubcategorias
            .map((solicitud) => solicitud.nombreSubfamilia)
            .filter(
                (value, index, self) =>
                    value &&
                    value !== null &&
                    value !== undefined &&
                    self.indexOf(value) === index
            )
            .sort(); // Ordenar alfabéticamente para consistencia
        setSubCategorias(allSubcategorias);
    }, [
        searchTerm,
        filterMuebles,
        filterNombreTarifa,
        filterEstado,
        filterCategoria,
        filterSubcategoria,
        filterDiasRestantes,
        filterFechaInformado,
        solicitudes,
    ]);

    // useEffect separado solo para la carga inicial de categorías y subcategorías
    useEffect(() => {
        if (
            solicitudes.length > 0 &&
            categorias.length === 0 &&
            subCategorias.length === 0
        ) {
            const allCategorias = solicitudes
                .map((solicitud) => {
                    return (
                        familiaMapping[solicitud.codFamilia] ||
                        familiaMapping[solicitud.codFamiliaProducto] ||
                        solicitud.categoria ||
                        solicitud.nombreCategoria ||
                        solicitud.familia ||
                        solicitud.nombreFamilia
                    );
                })
                .filter(
                    (value, index, self) =>
                        value &&
                        value !== null &&
                        value !== undefined &&
                        self.indexOf(value) === index
                );

            const allSubcategorias = solicitudes
                .map((solicitud) => solicitud.nombreSubfamilia)
                .filter(
                    (value, index, self) =>
                        value &&
                        value !== null &&
                        value !== undefined &&
                        self.indexOf(value) === index
                );

            setCategorias(allCategorias);
            setSubCategorias(allSubcategorias);
        }
    }, [solicitudes, categorias.length, subCategorias.length]);

    const handleOpenEditSolicitud = (solicitud) => {
        setEditSolicitud({
            codPrecioMueble: solicitud.codPrecioMueble,
            prototipo: solicitud.prototipo,
            precioUnidadIgnifugo: solicitud.precioUnidadIgnifugo,
            precioMasivo: solicitud.precioMasivo,
            cantidadPedidoMasivo: solicitud.cantidadPedidoMasivo,
            costeFabricacion: solicitud.costeFabricacion,
            costeMateriales: solicitud.costeMateriales,
            costeMaquinaria: solicitud.costeMaquinaria,
            costeManoObra: solicitud.costeManoObra,
            porcentajeBeneficioSobreCoste:
                solicitud.porcentajeBeneficioSobreCoste,
            codEstado: solicitud.codEstado,
        });
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const handleSelecteMueble = (selectedIds) => {
        setUsedFilter("mueble");
        setFilterMuebles(selectedIds);
    };

    const handleSelectNombreTarifa = (selectedIds) => {
        setUsedFilter("nombreTarifa");
        setFilterNombreTarifa(selectedIds);
    };

    const handleSelectEstado = (estadoName) => {
        setUsedFilter("estado");
        setFilterEstado((prevSelected) => {
            // Verificar si el estado ya está en la lista
            if (prevSelected.includes(estadoName)) {
                // Si ya está en la lista, eliminarla
                return prevSelected.filter((estado) => estado !== estadoName);
            } else {
                // Si no está, agregarla
                return [...prevSelected, estadoName];
            }
        });
    };

    const handleSelectCategoria = (categoriaName) => {
        setUsedFilter("categoria");
        setFilterCategoria((prevSelected) => {
            if (prevSelected.includes(categoriaName)) {
                return prevSelected.filter(
                    (categoria) => categoria !== categoriaName
                );
            } else {
                return [...prevSelected, categoriaName];
            }
        });
    };

    const handleSelectSubcategoria = (subcategoriaName) => {
        setUsedFilter("subcategoria");
        setFilterSubcategoria((prevSelected) => {
            if (prevSelected.includes(subcategoriaName)) {
                return prevSelected.filter(
                    (subcategoria) => subcategoria !== subcategoriaName
                );
            } else {
                return [...prevSelected, subcategoriaName];
            }
        });
    };

    const handleCleanFilter = () => {
        setFilterMuebles([]);
        setFilterNombreTarifa([]);
        setFilterEstado([]);
        setFilterCategoria([]);
        setFilterSubcategoria([]);
        setFilterDiasRestantes([]);
        setFilterFechaInformado([]);
    };

    const handleSendSolicitudTarifa = async (solicitud) => {
        try {
            solicitud.codEstado = 3;
            solicitud.fechaSolicitud = null;
            solicitud.fechaInformado = null;

            const response = await api.post(
                "/api/MueblesPrecios/AddMueblePrecio",
                currentSolicitud
            );

            if (response.status === 200) {
                notificationRef.current.addNotification(
                    `Tarifa enviada correctamente`,
                    "success"
                );
            }
            fetchSolicitudes();
        } catch (error) {
            notificationRef.current.addNotification(
                `Ha ocurrido un error al enviar la tarifa`,
                "error"
            );
        }
    };

    const handlePopupAccept = () => {
        if (
            currentSolicitud.nombreTarifa ===
                solicitudes.find(
                    (solicitud) =>
                        solicitud.codPrecioMueble ===
                        selectedSolicitudes[currentSolicitudIndex]
                ).nombreTarifa ||
            currentSolicitud.precioUnidad === 0
        ) {
            notificationRef.current.addNotification(
                "Cubre todos los campos obligatorios",
                "warning"
            );
            return;
        }
        const currentSolicitudId = selectedSolicitudes[currentSolicitudIndex];

        // Se elimina el elemento actual de la lista de solicitudes seleccionadas
        const updatedSelectedSolicitudes = selectedSolicitudes.filter(
            (id) => id !== currentSolicitudId
        );

        selectedSolicitudes.splice(currentSolicitudIndex, 1);

        setSelectedSolicitudes(updatedSelectedSolicitudes);

        // Se recalcula la lista actualizada de solicitudes seleccionadas
        const updatedSolicitudList = solicitudes.filter((solicitud) =>
            updatedSelectedSolicitudes.includes(solicitud.codPrecioMueble)
        );

        handleSendSolicitudTarifa(currentSolicitud);

        // Si ya no quedan solicitudes seleccionadas, se cierra el popup
        if (updatedSolicitudList.length === 0) {
            setIsPopupOpen(false);
        } else {
            // Si el índice actual es mayor o igual que la nueva longitud, se ajusta al último elemento
            if (currentSolicitudIndex >= updatedSolicitudList.length) {
                setCurrentSolicitudIndex(currentSolicitudIndex - 1);
            }
        }
    };

    const handlePrev = () => {
        if (currentSolicitudIndex > 0) {
            setCurrentSolicitudIndex(currentSolicitudIndex - 1);
        }
    };

    const handleNext = () => {
        if (currentSolicitudIndex < selectedSolicitudes.length - 1) {
            setCurrentSolicitudIndex(currentSolicitudIndex + 1);
        }
    };

    const handlePopupCancel = () => {
        setIsPopupOpen(false);
        setCurrentSolicitudIndex(0);
    };

    useEffect(() => {
        setCurrentSolicitud(
            solicitudes.find(
                (solicitud) =>
                    solicitud.codPrecioMueble ===
                    selectedSolicitudes[currentSolicitudIndex]
            )
        );
    }, [selectedSolicitudes, currentSolicitudIndex, solicitudes]);

    const isCalculated =
        Number(currentSolicitud?.costeFabricacion || 0) > 0 &&
        Number(currentSolicitud?.costeMateriales || 0) > 0 &&
        Number(currentSolicitud?.costeMaquinaria || 0) > 0 &&
        Number(currentSolicitud?.costeManoObra || 0) > 0 &&
        Number(currentSolicitud?.porcentajeBeneficioSobreCoste || 0) > 0;

    // useEffect que recalcula los precios automáticamente cuando se cumplen las condiciones
    useEffect(() => {
        if (isCalculated) {
            const computedPrice =
                (Number(currentSolicitud.costeFabricacion) +
                    Number(currentSolicitud.costeMateriales) +
                    Number(currentSolicitud.costeMaquinaria) +
                    Number(currentSolicitud.costeManoObra)) *
                (1 +
                    Number(currentSolicitud.porcentajeBeneficioSobreCoste) /
                        100);

            setCurrentSolicitud((prev) => ({
                ...prev,
                precioUnidad: computedPrice,
            }));
        }
    }, [currentSolicitud, isCalculated]);

    const handleOpenPopup = () => {
        const validSolicitudes = solicitudes.filter(
            (solicitud) =>
                selectedSolicitudes.includes(solicitud.codPrecioMueble) &&
                isSelectable(solicitud)
        );

        setSelectedSolicitudes(
            validSolicitudes.map((solicitud) => solicitud.codPrecioMueble)
        );

        if (selectedSolicitudes.length === 0) {
            notificationRef.current.addNotification(
                "Selecciona al menos una solicitud para enviar.",
                "warning"
            );
        } else if (validSolicitudes.length === 0) {
            notificationRef.current.addNotification(
                "Selecciona al menos una solicitud válida para enviar.",
                "warning"
            );
        } else {
            setIsPopupOpen(true);
        }
    };

    const isSelectable = (row) => {
        if (statesNoEdit.length > 0 && statesNoEdit.includes(row.codEstado)) {
            return false;
        }
        const requiredColumns = columnsTarifas.filter((col) => col.required);
        return requiredColumns.every(
            (col) =>
                row[col.key] !== undefined &&
                row[col.key] !== null &&
                row[col.key] !== "" &&
                row[col.key] !== 0
        );
    };

    const handleExportExcel = async () => {
        try {
        const api = getApiInstance();
        // Filtrar solo solicitudes del proveedor actual
        const solicitudesProveedor = solicitudes
            .filter(s => s.codEmpresa === user.codEmpresa)
            .map(s => s.codPrecioMueble);
        const seleccionadas = selectedSolicitudes.filter(id => solicitudesProveedor.includes(id));
        const response = await api.post(
            `/api/MueblesPrecios/ExportarMisTarifasPendientesExcel/${user.codEmpresa}`,
            seleccionadas,
            { responseType: "blob" }
        );

            if (response.status !== 200) {
                throw new Error("Error al descargar el archivo");
            }

            // Se obtiene el blob (archivo binario) del response
            const blob = await response.data;

            // Se crea un objeto URL para el blob
            const url = window.URL.createObjectURL(blob);

            // Se crea un enlace temporal para simular el click y forzar la descarga
            const a = document.createElement("a");
            a.href = url;

            // Intenta extraer el nombre de archivo desde el header Content-Disposition
            let fileName = "MisTarifasPendientes.xlsx";
            const disposition = response.headers.get("Content-Disposition");
            if (disposition && disposition.indexOf("filename=") !== -1) {
                const fileNameMatch = disposition.match(/filename="?([^"]+)"?/);
                if (fileNameMatch && fileNameMatch.length > 1) {
                    fileName = fileNameMatch[1];
                }
            }
            a.download = fileName;
            document.body.appendChild(a);
            a.click();

            // Se elimina el enlace y se revoca el objeto URL para liberar memoria
            a.remove();
            window.URL.revokeObjectURL(url);

            notificationRef.current.addNotification(
                "Archivo descargado correctamente.",
                "success"
            );
        } catch (error) {
            notificationRef.current.addNotification(
                "Error al descargar el archivo.",
                "error"
            );
            console.error("Error al descargar el archivo:", error);
        }
    };

    return (
        <section className="dashboard-usuarios">
            <div className="dashboard-usuarios__content__table-header">
                <InputSearch
                    context="tableSearch"
                    placeholder="Buscar..."
                    onSearch={setSearchTerm}
                />

                <Button
                    variant="outline"
                    label="Filtros"
                    icon={<FiFilter />}
                    onClick={() => setIsFiltersModalOpen(true)}
                />

                <Button
                    variant="filled"
                    label="Proponer nueva tarifa"
                    icon={<MdAttachMoney />}
                    onClick={handleOpenPopup}
                />
                <Button
                    label="Exportar"
                    variant="outline"
                    icon={<BiExport />}
                    onClick={handleExportExcel}
                    disabled={selectedSolicitudes.length === 0}
                />
            </div>

            <TableEditable
                columns={columnsTarifas}
                data={filteredSolicitudes}
                noResultsMessage="No hay solicitudes de tarifas."
                setData={setSolicitudes}
                rowKey="codPrecioMueble"
                onRowSelect={setSelectedSolicitudes}
                selectedRows={selectedSolicitudes}
                notificationRef={notificationRef}
                statesRestrictEdit={statesNoEdit}
            />

            <Modal
                title="Filtros"
                isOpen={isFiltersModalOpen}
                onClose={() => setIsFiltersModalOpen(false)}
                onAccept={() => setIsFiltersModalOpen(false)}
                outlineButtonLabel="Limpiar"
                primaryButtonLabel={`Ver resultados (${filteredSolicitudes.length})`}
                onCancel={handleCleanFilter}
            >
                <div className="modal-inputs">
                    <div className="section-header__modal__section">
                        <InputDropdown
                            label="Mueble"
                            options={mueblesOptions.map((mueble) => ({
                                label: mueble.nombre,
                                value: mueble.id,
                            }))}
                            onSelect={handleSelecteMueble}
                            withCheckboxes={true}
                            hasSearch={true}
                        />
                    </div>
                    <div className="section-header__modal__section">
                        <InputDropdown
                            label="Nombre Tarifa"
                            options={tarifasOptions.map((tarifa) => ({
                                label: tarifa.nombre,
                                value: tarifa.id,
                            }))}
                            onSelect={handleSelectNombreTarifa}
                            withCheckboxes={true}
                            hasSearch={true}
                        />
                    </div>

                    <div className="section-header__modal__section">
                        <DateRangeCalendar
                            label="Fecha de Solicitud"
                            onAccept={(range) => {
                                setFilterFechaSolicitud({
                                    startDate: range.start,
                                    endDate: range.end,
                                });
                            }}
                            onClear={() => {
                                setFilterFechaSolicitud({});
                            }}
                            initialStartDate={filterFechaSolicitud.startDate}
                            initialEndDate={filterFechaSolicitud.endDate}
                        />
                    </div>

                    <div className="section-header__modal__section">
                        <Accordion title="Categoría">
                            <ul className="section-header__modal__section__content">
                                {categorias.map((categoria, index) => (
                                    <Tag
                                        key={index}
                                        label={categoria}
                                        isSelected={filterCategoria.includes(
                                            categoria
                                        )}
                                        onSelect={handleSelectCategoria}
                                    />
                                ))}
                            </ul>
                        </Accordion>
                    </div>

                    <div className="section-header__modal__section">
                        <Accordion title="Subcategoría">
                            <ul className="section-header__modal__section__content">
                                {subCategorias.map((subcategoria, index) => (
                                    <Tag
                                        key={index}
                                        label={subcategoria}
                                        isSelected={filterSubcategoria.includes(
                                            subcategoria
                                        )}
                                        onSelect={handleSelectSubcategoria}
                                    />
                                ))}
                            </ul>
                        </Accordion>
                    </div>

                    <div className="section-header__modal__section">
                        <Accordion title="Estado">
                            <ul className="section-header__modal__section__content">
                                {estadosOptions.map((estado) => (
                                    <Tag
                                        key={estado.id}
                                        label={estado.nombre}
                                        isSelected={filterEstado.includes(
                                            estado
                                        )}
                                        onSelect={() =>
                                            handleSelectEstado(estado)
                                        }
                                    />
                                ))}
                            </ul>
                        </Accordion>
                    </div>
                    {/* <div className="section-header__modal__section">
                                <InputDropdown
                                    label="Comparativa"
                                    options={[
                                        { label: "Precio más bajo", value: "bajo" },
                                        { label: "Diferencia porcentual", value: "diferencia" }
                                    ]}
                                    onSelect={handleSelectComparativa}
                                    withCheckboxes={false}
                                    hasSearch={false}
                                />
                            </div> */}
                    {/* <div className="section-header__modal__section">
                                <Input
                                    label="Días Restantes (mínimo)"
                                    type="number"
                                    placeholder="Min"
                                    value={filterDiasRestantes[0] || ""}
                                    onChange={(e) => handleChangeDiasRestantes(0, e.target.value)}
                                />
                                <Input
                                    label="Días Restantes (máximo)"
                                    type="number"
                                    placeholder="Max"
                                    value={filterDiasRestantes[1] || ""}
                                    onChange={(e) => handleChangeDiasRestantes(1, e.target.value)}
                                />
                            </div> */}
                    {/* <div className="section-header__modal__section">
                                <Input
                                    label="Fecha Informado - Desde"
                                    type="date"
                                    value={filterFechaInformado[0] || ""}
                                    onChange={(e) => handleChangeFechaInformado(0, e.target.value)}
                                />
                                <Input
                                    label="Fecha Informado - Hasta"
                                    type="date"
                                    value={filterFechaInformado[1] || ""}
                                    onChange={(e) => handleChangeFechaInformado(1, e.target.value)}
                                />
                            </div> */}
                </div>
            </Modal>

            <Modal
                title="Precios desglosados"
                isOpen={isModalOpen}
                onClose={closeModal}
                outlineButtonLabel="Cancelar"
            >
                <div className="dashboard-usuarios__modal">
                    <form
                        className="dashboard-usuarios__modal__content"
                        autoComplete="off"
                    >
                        <Input
                            label="Prototipo"
                            value={editSolicitud?.prototipo}
                            onChange={(e) =>
                                setEditSolicitud({
                                    ...editSolicitud,
                                    prototipo: e.target.value,
                                })
                            }
                            disabled={true}
                        />
                        <Input
                            label="Precio Unidad Ignífugo"
                            value={editSolicitud?.precioUnidadIgnifugo}
                            onChange={(e) =>
                                setEditSolicitud({
                                    ...editSolicitud,
                                    precioUnidadIgnifugo: e.target.value,
                                })
                            }
                            disabled={true}
                        />
                        <Input
                            label="Precio Masivo"
                            value={editSolicitud?.precioMasivo}
                            onChange={(e) =>
                                setEditSolicitud({
                                    ...editSolicitud,
                                    precioMasivo: e.target.value,
                                })
                            }
                            disabled={true}
                        />
                        <Input
                            label="Cantidad Pedido Masivo"
                            value={editSolicitud?.cantidadPedidoMasivo}
                            onChange={(e) =>
                                setEditSolicitud({
                                    ...editSolicitud,
                                    cantidadPedidoMasivo: e.target.value,
                                })
                            }
                            disabled={true}
                        />
                        <Input
                            label="Coste Fabricación"
                            value={editSolicitud?.costeFabricacion}
                            onChange={(e) =>
                                setEditSolicitud({
                                    ...editSolicitud,
                                    costeFabricacion: e.target.value,
                                })
                            }
                            disabled={true}
                        />
                        <Input
                            label="Coste Materiales"
                            value={editSolicitud?.costeMateriales}
                            onChange={(e) =>
                                setEditSolicitud({
                                    ...editSolicitud,
                                    costeMateriales: e.target.value,
                                })
                            }
                            disabled={true}
                        />
                        <Input
                            label="Coste Maquinaria"
                            value={editSolicitud?.costeMaquinaria}
                            onChange={(e) =>
                                setEditSolicitud({
                                    ...editSolicitud,
                                    costeMaquinaria: e.target.value,
                                })
                            }
                            disabled={true}
                        />
                        <Input
                            label="Coste Mano Obra"
                            value={editSolicitud?.costeManoObra}
                            onChange={(e) =>
                                setEditSolicitud({
                                    ...editSolicitud,
                                    costeManoObra: e.target.value,
                                })
                            }
                            disabled={true}
                        />
                        <Input
                            label="Porcentaje Beneficio Sobre Coste"
                            value={editSolicitud?.porcentajeBeneficioSobreCoste}
                            onChange={(e) =>
                                setEditSolicitud({
                                    ...editSolicitud,
                                    porcentajeBeneficioSobreCoste:
                                        e.target.value,
                                })
                            }
                            disabled={true}
                        />
                    </form>
                </div>
            </Modal>

            {/* {isPopupOpen && (
                <Popup
                    type="alert"
                    alertType="warning"
                    titleMessage="Confirmar eliminación"
                    alertMessage="¿Estás seguro de que deseas eliminar este elemento?"
                    onConfirm={handleConfirmDelete}
                    onClose={handleCancelDelete}
                    confirmLabel="Eliminar"
                    cancelLabel="Cancelar"
                />
            )}  */}

            {isPopupOpen && (
                <Popup
                    type="info"
                    titleMessage="Proponer nuevas tarifas"
                    onConfirm={handlePopupAccept}
                    onClose={handlePopupCancel}
                    confirmLabel="Aceptar"
                    cancelLabel="Cancelar"
                >
                    <form className="gestion-muebles__modal__form">
                        {currentSolicitud && (
                            <div key={currentSolicitud.codPrecioMueble}>
                                {/* Campos de referencia */}
                                <div
                                    className="solicitud-referencia"
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "8px",
                                        borderBottom: "1px solid #e0e0e0",
                                        marginBottom: "16px",
                                    }}
                                >
                                    <p style={{ fontSize: "14px" }}>
                                        <strong>Nombre Mueble:</strong>{" "}
                                        {currentSolicitud.nombreMueble}
                                    </p>
                                    <p style={{ fontSize: "14px" }}>
                                        <strong>Referencia:</strong>{" "}
                                        {currentSolicitud.referencia}
                                    </p>
                                    <div>
                                        <strong style={{ fontSize: "14px" }}>
                                            Imagen:
                                        </strong>
                                        <br />
                                        <img
                                            src={
                                                currentSolicitud.rutaImagenMueble
                                            }
                                            alt="Imagen del mueble"
                                            style={{
                                                maxWidth: "140px",
                                                margin: "16px",
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Campos editables de precio y costes */}
                                <div
                                    className="solicitud-formulario"
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "16px",
                                    }}
                                >
                                    <Input
                                        type="text"
                                        label={"Nombre Tarifa"}
                                        onChange={(e) =>
                                            setCurrentSolicitud({
                                                ...currentSolicitud,
                                                nombreTarifa: e.target.value,
                                            })
                                        }
                                    />
                                    <Input
                                        type="number"
                                        label={"Precio Unidad"}
                                        value={currentSolicitud.precioUnidad}
                                        onChange={(e) =>
                                            setCurrentSolicitud({
                                                ...currentSolicitud,
                                                precioUnidad: e.target.value,
                                            })
                                        }
                                        // Si el precio se calculó automáticamente, se deshabilita la edición
                                        disabled={isCalculated}
                                    />
                                    <Input
                                        type="number"
                                        label={"Precio Unidad Ignífugo"}
                                        value={
                                            currentSolicitud.precioUnidadIgnifugo
                                        }
                                        onChange={(e) =>
                                            setCurrentSolicitud({
                                                ...currentSolicitud,
                                                precioUnidadIgnifugo:
                                                    e.target.value,
                                            })
                                        }
                                    />
                                    <Input
                                        type="number"
                                        label={"Precio Masivo"}
                                        value={currentSolicitud.precioMasivo}
                                        onChange={(e) =>
                                            setCurrentSolicitud({
                                                ...currentSolicitud,
                                                precioMasivo: e.target.value,
                                            })
                                        }
                                    />
                                    <Input
                                        type="number"
                                        label={"Cantidad Pedido Masivo"}
                                        value={
                                            currentSolicitud.cantidadPedidoMasivo
                                        }
                                        onChange={(e) =>
                                            setCurrentSolicitud({
                                                ...currentSolicitud,
                                                cantidadPedidoMasivo:
                                                    e.target.value,
                                            })
                                        }
                                    />
                                    <Input
                                        type="number"
                                        label={"Coste Fabricación"}
                                        value={
                                            currentSolicitud.costeFabricacion
                                        }
                                        onChange={(e) =>
                                            setCurrentSolicitud({
                                                ...currentSolicitud,
                                                costeFabricacion:
                                                    e.target.value,
                                            })
                                        }
                                    />
                                    <Input
                                        type="number"
                                        label={"Coste Materiales"}
                                        value={currentSolicitud.costeMateriales}
                                        onChange={(e) =>
                                            setCurrentSolicitud({
                                                ...currentSolicitud,
                                                costeMateriales: e.target.value,
                                            })
                                        }
                                    />
                                    <Input
                                        type="number"
                                        label={"Coste Maquinaria"}
                                        value={currentSolicitud.costeMaquinaria}
                                        onChange={(e) =>
                                            setCurrentSolicitud({
                                                ...currentSolicitud,
                                                costeMaquinaria: e.target.value,
                                            })
                                        }
                                    />
                                    <Input
                                        type="number"
                                        label={"Coste Mano de Obra"}
                                        value={currentSolicitud.costeManoObra}
                                        onChange={(e) =>
                                            setCurrentSolicitud({
                                                ...currentSolicitud,
                                                costeManoObra: e.target.value,
                                            })
                                        }
                                    />
                                    <Input
                                        type="number"
                                        label={
                                            "Porcentaje Beneficio Sobre Coste"
                                        }
                                        value={
                                            currentSolicitud.porcentajeBeneficioSobreCoste
                                        }
                                        onChange={(e) =>
                                            setCurrentSolicitud({
                                                ...currentSolicitud,
                                                porcentajeBeneficioSobreCoste:
                                                    e.target.value,
                                            })
                                        }
                                    />
                                    <Input
                                        type="text"
                                        label={"Comentarios Proveedor"}
                                        value={
                                            currentSolicitud.comentariosProveedor
                                        }
                                        onChange={(e) =>
                                            setCurrentSolicitud({
                                                ...currentSolicitud,
                                                comentariosProveedor:
                                                    e.target.value,
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        )}

                        <div
                            className="navigation-buttons"
                            style={{
                                margin: "16px 0",
                                display: "flex",
                                justifyContent: "space-between",
                            }}
                        >
                            <button
                                type="button"
                                onClick={handlePrev}
                                disabled={currentSolicitudIndex === 0}
                                style={{ fontSize: "14px" }}
                            >
                                &#8592; Anterior
                            </button>
                            <button
                                type="button"
                                onClick={handleNext}
                                disabled={
                                    currentSolicitudIndex ===
                                    selectedSolicitudes.length - 1
                                }
                            >
                                Siguiente &#8594;
                            </button>
                        </div>
                    </form>
                </Popup>
            )}

            <Notification ref={notificationRef} />
        </section>
    );
}
